module.exports = __webpack_public_path__ + "img/funding-new7.61e94685.png";